import { useEffect, useState } from "react";
import SiteMenu from "@/components/SiteMenu";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import CelestialBackground from "@/components/CelestialBackground";
import { Medal } from "@/components/StreakBadges";
import { api } from "@/lib/apiClient";
import { PUBLIC_HOME } from "@/lib/native";

export default function BadgePage() {
  const { code } = useParams();
  const [params] = useSearchParams();
  const [b, setB] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/badge/${code}`)
      .then(({ data }) => {
        setB(data);
        localStorage.setItem("astra_ref", data.code);
      })
      .catch(() => setError(true));
  }, [code]);

  const want = Number(params.get("d")) || 7;
  const earned = b?.badges.filter((x) => x.earned) || [];
  const shown = [...earned].reverse().find((x) => x.days <= want) || earned[earned.length - 1];

  return (
    <div className="app-shell relative text-starlight" data-testid="badge-page">
      <CelestialBackground />
      <SiteMenu floating />
      <div className="relative z-10 min-h-[100dvh] flex flex-col items-center justify-center px-6 text-center safe-top pb-10">
        {!b && !error && <Loader2 className="animate-spin gold-text" size={28} />}
        {error && <p className="text-[#A7B0C0]">This badge couldn't be found.</p>}
        {b && (
          <div className="fade-up flex flex-col items-center">
            <p className="text-[11px] uppercase tracking-[0.3em] gold-text mb-6">Astra streak badge</p>
            {shown ? <Medal days={shown.days} earned size={150} /> : <Medal days={7} earned={false} size={150} />}
            <h1 data-testid="badge-title" className="text-3xl font-light mt-6">
              {shown ? `${b.name} earned ${shown.name}` : `${b.name} is building a streak`}
            </h1>
            <p className="text-[#A7B0C0] mt-3 max-w-xs">
              {shown ? `${shown.days} days in a row reading the stars on Astra.` : "Reading the stars every day on Astra."}{" "}
              Join with this link and you both get free Astra Interactive questions.
            </p>
            <Link to="/join" data-testid="btn-badge-join" className="mt-8 w-full max-w-xs bg-[#D4AF37] hover:bg-[#e6c04e] text-[#04060B] font-medium text-lg py-3.5 rounded-full transition-colors">
              Get your free reading
            </Link>
            <Link to={PUBLIC_HOME} data-testid="link-badge-home" className="mt-4 text-sm text-[#A7B0C0] hover:text-starlight">
              Browse today's horoscopes
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
